import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-alert.tsx
var LazyCourseAlert = lazy(() => import("./course-alert-CnCzJiN7.js").then((n) => n.n).then((module) => ({ default: module.CourseAlert })));
function CourseAlert({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-alert" }),
		children: /* @__PURE__ */ jsx(LazyCourseAlert, { ...props })
	});
}
function CourseAlertContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-alert" }),
		children: /* @__PURE__ */ jsx(LazyCourseAlert, { ...props })
	});
}
var useCourseAlertContent = () => {
	return useMemo(() => ({ courseAlert: { component: CourseAlertContent } }), []);
};
//#endregion
export { CourseAlert, useCourseAlertContent };
